<script>
  import { useForm, router } from '@inertiajs/svelte'
  import Layout from '../../layouts/layout.svelte'
  import PageHeader from '../../components/page_header.svelte'
  import FormLayout from '../../components/form_layout.svelte'
  import FormSection from '../../components/form_section.svelte'
  import TextField from '../../components/form/text_field.svelte'
  import CheckboxField from '../../components/form/checkbox_field.svelte'
  import SubmitButton from '../../components/form/submit_button.svelte'
  import { Button, Icon } from '../../components/ui'
  import { liveValidate } from '../../lib/live_validation.svelte.js'
  import { confirm } from '../../components/confirm.js'

  let { admin, back_url: backUrl = '/admins', abilities = [], ability_checks = {}, can_manage_abilities = false } = $props()

  // Validation is the server's (live Precognition requests + Save).
  const form = useForm({
    admin: { name: admin.name || '', email: admin.email || '', ability_names: { ...ability_checks } },
    return_to: backUrl
  }).withPrecognition('put', `/admins/${admin.id}`)
  liveValidate(form, 'admin')

  const submit = (e) => {
    e.preventDefault()
    $form.put(`/admins/${admin.id}`)
  }

  const archive = async () => {
    const ok = await confirm({
      title: 'Confirm Archive',
      variant: 'error',
      body: 'Archiving is permanent unless reversed by a developer. Are you sure?'
    })
    if (!ok) return
    router.delete(`/admins/${admin.id}`, { data: { return_to: backUrl } })
  }
</script>

<Layout>
  <PageHeader title="Edit Admin" subtitle="Team member access and permissions" back={backUrl}>
    {#snippet actions()}
      <Button variant="ghost" size="sm" icon="delete" class="text-error" onclick={archive}>Archive</Button>
    {/snippet}
  </PageHeader>

  <FormLayout onsubmit={submit}>
    <FormSection title="Details">
      <TextField bind:value={$form.admin.email} label="Email" name="email" error={$form.errors['admin.email']} />
      <TextField bind:value={$form.admin.name} label="Full Name" name="name" error={$form.errors['admin.name']} />
    </FormSection>

    <FormSection>
      <h2 class="font-semibold text-sm flex items-center gap-1">
        Permissions
        {#if !can_manage_abilities}
          <span class="text-base-content/40" title="Requires the Abilities permission to change permissions">
            <Icon name="lock" size="xs" />
          </span>
        {/if}
      </h2>
      <div class="grid grid-cols-2 gap-x-4 gap-y-2" class:opacity-50={!can_manage_abilities}>
        {#each abilities as ability (ability.name)}
          <CheckboxField
            bind:checked={$form.admin.ability_names[ability.name]}
            label={ability.label}
            name={`ability_${ability.name}`}
            disabled={!can_manage_abilities}
          />
        {/each}
      </div>
    </FormSection>

    {#snippet footer()}
      <Button href={backUrl} variant="ghost" size="sm">Cancel</Button>
      <SubmitButton processing={$form.processing} full={false} />
    {/snippet}
  </FormLayout>
</Layout>
